import { useState, useEffect, useCallback, useRef } from 'react';
import { getCashiers } from '../services/cashiersApi';

export function useCashiers(params = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);
  const paramsRef = useRef(params);

  useEffect(() => {
    paramsRef.current = params;
  }, [params]);

  const fetchData = useCallback(async () => {
    if (!mountedRef.current) return;
    const currentParams = paramsRef.current;
    setLoading(true);
    setError(null);
    try {
      const list = await getCashiers(currentParams);
      if (!mountedRef.current) return;
      setData(Array.isArray(list) ? list : []);
    } catch (err) {
      if (!mountedRef.current) return;
      setError(err instanceof Error ? err : new Error(String(err)));
      setData(null);
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    fetchData();
    return () => {
      mountedRef.current = false;
    };
  }, [fetchData]);

  useEffect(() => {
    if (mountedRef.current) {
      fetchData();
    }
  }, [JSON.stringify(params)]); // eslint-disable-line react-hooks/exhaustive-deps

  return { data, loading, error, refetch: fetchData };
}
